import { scrollTo } from '@flos/react-ui';
import { IScrollToOptions } from '@flos/react-ui/build/utils/scroll-to';
import { useEffect, useRef } from 'react';

const useRefreshableScrollOnMount = <T extends HTMLElement>(
  scrollOptions: IScrollToOptions = {},
  refresh: any = {}
) => {
  const { offset = 110, behavior } = scrollOptions;
  const targetRef = useRef<null | T>(null);
  useEffect(() => {
    if (targetRef.current) {
      scrollTo(targetRef.current, {
        behavior,
        offset,
      });
    }
  }, [offset, behavior, refresh]);
  return targetRef;
};

export default useRefreshableScrollOnMount;
